import React from 'react';
import videojs from 'video.js'

class VideoPlayer extends React.Component {
    constructor() {
        super();
        this.updateProgress = this.updateProgress.bind(this);
        this.progressInterval = setInterval(this.updateProgress, 5000);

    }
    
  componentDidMount() {
    // instantiate Video.js
    // this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
    //   console.log('onPlayerReady', this)
    // });
  }

  // destroy player on unmount
  componentWillUnmount() {
    // if (this.player) {
    //   this.player.dispose()
    // }
  }

  componentWillReceiveProps(newProps) {
    // When a user moves from one title to the next, the VideoPlayer component will not be unmounted,
    // instead its properties will be updated with the details of the new video. In this case,
    // we can update the src of the existing player with the new video URL.
    // if (this.player) {
    //     console.log(this.player.currentSrc());
    //     if (newProps.sources[0].src != this.player.currentSrc()) {
    //         this.player.src(newProps.sources[0].src);
    //     }
    // } 
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    // const {forwardedRef} = this.props;
    return (
      <div>	
        <div data-vjs-player {...this.props}>
          <video className="video-js" id="video-player-id"></video>
        </div>
      </div>
    )
  }
  updateProgress = () => {    
    let currentTime;
    // player
    //   .getCurrentTime()
    //   .then((seconds) => {
    //     const { queue } = this.props;
    //     currentTime = seconds;
    //     if (currentTime.toFixed(0) >= 1680) {
    //       currentTime = 0;
    //     }
    //     const req = new Request(
    //       `https://${apiUrl}/api/v1/user_progress?video_id=${
    //         queue.content[queue.index].id
    //       }&progress_in_seconds=${currentTime.toFixed(0)}&token=${
    //         this.props.user.token
    //       }`,
    //       {
    //         method: "POST"
    //       }
    //     );
    //     fetch(req).then(response => {
    //     });
    //   })
    //   .catch(function(error) {
    //     console.log('error here?')
    //     console.log(error);
    //   });
  }
}

// export default React.forwardRef((props, ref) => {
//     return <VideoPlayer {...props} forwardedRef={ref} />;
// });

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/js/Components/Home/VideoPlayer.jsx